import * as Sentry from "@sentry/react";

function getDsn(): string | undefined {
  if (typeof process !== "undefined" && process.env?.EXPO_PUBLIC_SENTRY_DSN) {
    return process.env.EXPO_PUBLIC_SENTRY_DSN;
  }

  if (typeof window !== "undefined" && (window as unknown as Record<string, unknown>).__ENV__) {
    const env = (window as unknown as Record<string, unknown>).__ENV__ as Record<string, unknown>;
    if (typeof env.SENTRY_DSN === "string") return env.SENTRY_DSN;
  }

  return undefined;
}

function getRelease(): string | undefined {
  if (typeof window !== "undefined" && (window as unknown as Record<string, unknown>).__ENV__) {
    const env = (window as unknown as Record<string, unknown>).__ENV__ as Record<string, unknown>;
    if (typeof env.SENTRY_RELEASE === "string") return env.SENTRY_RELEASE;
  }
  return undefined;
}

function isDntEnabled(): boolean {
  if (typeof navigator === "undefined") return false;

  const nav = navigator as unknown as Record<string, unknown>;
  const dnt = nav.doNotTrack;
  if (dnt === "1" || dnt === 1 || dnt === "yes") return true;

  if (typeof window !== "undefined") {
    const win = window as unknown as Record<string, unknown>;
    if (win.doNotTrack === "1" || win.doNotTrack === 1 || win.doNotTrack === "yes") return true;
  }

  if (nav.globalPrivacyControl === true) return true;

  return false;
}

export function initSentry() {
  const dsn = getDsn();
  if (!dsn) return;

  if (isDntEnabled()) {
    return;
  }

  Sentry.init({
    dsn,
    release: getRelease(),
    environment:
      typeof process !== "undefined" && process.env?.NODE_ENV === "production"
        ? "production"
        : "development",
    tracesSampleRate:
      typeof process !== "undefined" && process.env?.NODE_ENV === "production" ? 0.1 : 1.0,
  });
}

export function setSentryUser(user: { id: string; email?: string; name?: string }) {
  Sentry.setUser({ id: user.id, email: user.email, username: user.name });
}

export function clearSentryUser() {
  Sentry.setUser(null);
}

export { Sentry };
